import React from 'react'

const NotFound = () => {
    return (
        <h1 className="text-center">404😌</h1>
    )
}

export default NotFound
